export interface JwtPayload {
  employeeId?: string;
  companyId?: string;
  guidEmpresa?: string;
  email?: string;
  fullName?: string;
  role?: string | string[];
  jti?: string;
  exp?: number;
  iss?: string;
  aud?: string;
  // Claims exclusivos de sesiones SSO (ausentes en login normal)
  sessionId?: string;
  SSORexUserId?: string;
}

/**
 * Decodifica el payload de un JWT (sin verificar firma).
 * Maneja tanto base64 estándar como base64url.
 */
export const decodeJwtPayload = (token: string): JwtPayload => {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return {};
    // base64url → base64 estándar
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    // globalThis.atob is available in browsers and Deno (no-undef safe)
    const payload = globalThis.atob(base64);
    return JSON.parse(payload) as JwtPayload;
  } catch {
    return {};
  }
};

/**
 * Determina si un JWT corresponde a una sesión SSO (Rex+).
 * Una sesión SSO tiene los claims `SSORexUserId` y `sessionId` presentes.
 */
export const isSSOSession = (token: string): boolean => {
  const payload = decodeJwtPayload(token);
  return !!payload.SSORexUserId && !!payload.sessionId;
};
